"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _EmergencyContactsListEditor = _interopRequireDefault(require("./EmergencyContactsListEditor"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _EmergencyContactsListEditor.default;
exports.default = _default;